import type { PlayActionType } from './petBalance';

export interface PetPlayOption {
  id: PlayActionType;
  name: string;
  emoji: string;
  description: string;
}

export const PET_PLAY_OPTIONS: PetPlayOption[] = [
  { id: 'stroke', name: '쓰다듬기', emoji: '🤚', description: '부드럽게 쓰다듬어 친밀도를 높여요' },
  { id: 'ball', name: '공 던져주기', emoji: '⚽', description: '공을 던져 신나게 뛰어놀아요' },
  { id: 'feather', name: '깃털 놀기', emoji: '🪶', description: '깃털 장난감을 쫓으며 놀아요' },
  { id: 'laser', name: '레이저 놀기', emoji: '🔴', description: '레이저 포인터를 쫓아요' }
];
